import Axios, { AxiosInstance } from 'axios'

import { apiConstants, ApiConstantsInterface } from '@plugin/Common/constants/related-products/api.constants'
import { appConstants } from '@plugin/Common/constants/related-products/app.constants'
import { RelatedProductInterface } from '@plugin/Common/interfaces/related-products/related-product.interface'

interface RelatedProductsServiceInterface {
  getRelatedProductsById(productId: number): Promise<RelatedProductInterface[]>
}

export class RelatedProductsService implements RelatedProductsServiceInterface {
  protected axios: AxiosInstance

  protected config: ApiConstantsInterface

  constructor(config: ApiConstantsInterface) {
    this.config = config
    this.axios = Axios.create({
      baseURL: config.baseUrl,
    })
  }

  async getRelatedProductsById(productId: number): Promise<RelatedProductInterface[]> {
    const relatedProductsResponse = await this.axios.get(this.config.getRelatedProducts(productId), {
      params: {
        thumbnailSize: appConstants.productThumbnailSize,
      },
    })
    return this.convertResponse(relatedProductsResponse.data)
  }

  protected convertResponse(response: any): RelatedProductInterface[] {
    return response.map((record) => ({
      id: record.ProductOverview.Id,
      imageUrl: record.ProductOverview.DefaultPictureModel?.ImageUrl,
      metaTitle: record.SEOMetaTitle,
      price: record.ProductOverview.ProductPrice?.PriceValue,
      seName: record.ProductOverview.SeName,
      title: record.ProductOverview.Name,
      useLegacy: record.ProductOverview.UseLegacy,
      url: record.ProductOverview.Url 
    }))
  }
}

const relatedProductsService = new RelatedProductsService(apiConstants)
export { relatedProductsService }
